import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mDevice from 'models/device';
// Custom
import { getDevicesAutocomplete } from 'actions';
import { deviceDataShape, autoCompleteDataShape } from 'constants/PropTypesShapes';
import AutoCompleteSearchFieldFilter from 'components/filters/AutoCompleteSearchFieldFilter';
import InformationItem from 'components/items/InformationItem';

const DeviceAutoCompleteItem = ({ element, onSelect }) => {
  if (element) {
    const device = { ...element };
    const { icon, color } = mDevice.status(device);
    // If defined, display installation and device names
    const { installation } = device;
    let desc = <LocalizedMessage id="info.deviceNoInstallationShort" />;
    if (installation) {
      desc = installation.name;
    }

    return (
      <div className="information-item-wrapper">
        <InformationItem
          icon={icon}
          iconColor={color}
          label={desc}
          value={mDevice.installationDesc(device)}
          onClick={() => onSelect(device)}
        />
      </div>
    );
  }
  return null;
};

DeviceAutoCompleteItem.propTypes = {
  element: deviceDataShape,
  onSelect: PropTypes.func,
};

DeviceAutoCompleteItem.defaultProps = {
  element: null,
  onSelect: null,
};

class DeviceAutoCompleteFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleGetDevices = this.handleGetDevices.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
  }

  // Handlers
  handleGetDevices(value, page) {
    const { handleGetDevicesAutocomplete } = this.props;
    // Get default devices list features
    const { defaultParams: { pagination, sort }, autoCompleteFilter } = mDevice.listFeatures();
    // Define the page to be loaded
    const finalPagination = {
      page: page || pagination.page,
      pageSize: pagination.pageSize,
    };
    // Launch devices loading
    const filter = { ...autoCompleteFilter, value };
    handleGetDevicesAutocomplete(finalPagination, sort, [filter]);
  }

  handleSelectElement(device) {
    const { onSelect } = this.props;
    onSelect(device);
  }

  render() {
    const { device, devices: { loading, elements, pagination } } = this.props;

    return (
      <AutoCompleteSearchFieldFilter
        label="field.device"
        element={device}
        loading={loading}
        elements={elements}
        pagination={pagination}
        elementComp={
          <DeviceAutoCompleteItem />
        }
        onGetElements={this.handleGetDevices}
        elementDescBuilder={(element) => (element.serial)}
        onSelectElement={this.handleSelectElement}
      />
    );
  }
}

DeviceAutoCompleteFilter.propTypes = {
  device: deviceDataShape,
  devices: autoCompleteDataShape.isRequired,
  onSelect: PropTypes.func.isRequired,
  handleGetDevicesAutocomplete: PropTypes.func.isRequired,
};

DeviceAutoCompleteFilter.defaultProps = {
  device: null,
};

const mapStateToProps = (state) => ({
  devices: state.autoComplete.devices,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetDevicesAutocomplete: (pagination, sort, filters) => {
    dispatch(getDevicesAutocomplete(pagination, sort, filters));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceAutoCompleteFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceAutoCompleteFilter.js